import { FindexClient } from "@/integrations/findex";
import { type IUserWorth } from "findef";
import { computed, type ComputedRef, type Ref, ref } from "vue";

export type UseUserWorth = {
  worth: ComputedRef<IUserWorth>;
  isLoading: ComputedRef<boolean>;
  refresh: () => Promise<void>;
};

const emptyWorth: IUserWorth = {
  assetCount: 0,
  liabilityCount: 0,
  currency: "",
  diversification: [],
  invested: 0,
  roi: 0,
  roiValue: 0,
  user: "",
  value: 0,
  valueChange: 0,
  valueChangePercent: 0,
  totalAmortization: 0,
  totalNetWorth: 0,
  totalAssetValue: 0,
};

const userWorth: Ref<IUserWorth | null> = ref(null);
const isLoading: Ref<boolean> = ref<boolean>(false);

export const useUserWorth = (): UseUserWorth => {
  const refresh = async () => {
    const [data] = await FindexClient.getUserWorth();
    if (data) {
      userWorth.value = data;
    }
  };

  if (!userWorth.value) {
    refresh().catch((e) => console.error(e));
  }

  const worth = computed(() => userWorth.value || emptyWorth);

  return {
    worth,
    refresh,
    isLoading: computed(() => !!isLoading.value),
  };
};
